/* tslint:disable */
/* eslint-disable */
export enum WorkConnectorWebhookEventStatusEnum {
  Received = 'received',
  Processed = 'processed',
  Failed = 'failed',
  Ignored = 'ignored'
}
